import React from 'react';
import PropTypes from 'prop-types';

import { Modal, Button } from 'semantic-ui-react';

class EditRecurrenceTaskConfirmModal extends React.PureComponent {
  render() {
    return (
      <div>
        <Modal
          size={this.props.size}
          open={this.props.open}
          onClose={() => {
            this.props.close(this.props.toggleModalStateKey, false);
          }}
          centered
        >
          <Modal.Header>Edit Recurrence Task</Modal.Header>
          <Modal.Content>Do you want to edit this occurrence or its series?</Modal.Content>
          <Modal.Actions>
            <Button
              basic
              type="button"
              onClick={() => {
                this.props.close(this.props.toggleModalStateKey, false);
              }}
            >
              Cancel
            </Button>
            <Button primary type="button" onClick={() => this.props.editTaskRecurrence(true)}>
              Occurrence
            </Button>
            <Button primary type="button" onClick={() => this.props.editTaskRecurrence(false)}>
              Series
            </Button>
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}
EditRecurrenceTaskConfirmModal.propTypes = {
  size: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  toggleModalStateKey: PropTypes.any,
  editTaskRecurrence: PropTypes.func.isRequired,
};

export default EditRecurrenceTaskConfirmModal;
